"use client";
import React, { useRef, useState, useEffect } from "react";
import {
  Box,
  Typography,
  IconButton,
  Card,
  Grid,
  CardMedia,
  useMediaQuery,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { YouTubeEmbed } from "@next/third-parties/google";
import Arrows from "../carouselComponent/arrows";
import ContentHeader from "../ContentHeader/ContentHeader";
import { WEB_COLORS } from "@/lib/constants";

const videos = [
  {
    title: "Engage & Grow",
    type: "thumbnail",
    image: "/videos/engage.jpg",
  },
  {
    title: "The complete guide",
    type: "youtube",
    videoId: "exampleVideoId",
  },
  {
    title: "Stories",
    type: "thumbnail",
    image: "/videos/stories.jpg",
  },
  {
    title: "Stories",
    type: "thumbnail",
    image: "/videos/stories.jpg",
  },
  {
    title: "Stories",
    type: "thumbnail",
    image: "/videos/stories.jpg",
  },
  {
    title: "Stories",
    type: "thumbnail",
    image: "/videos/stories.jpg",
  },
  {
    title: "Stories",
    type: "thumbnail",
    image: "/videos/stories.jpg",
  },
  {
    title: "Stories",
    type: "thumbnail",
    image: "/videos/stories.jpg",
  },
];

const VideoCarousel = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [activeIndex, setActiveIndex] = useState(0);
  const videoRefs = useRef([]);

  const scrollToCenter = (index) => {
    videoRefs.current[index]?.scrollIntoView({
      behavior: "smooth",
      inline: "center",
      block: "nearest",
    });
  };


  const handlePrev = () => {
    const newIndex = activeIndex === 0 ? videos.length - 1 : activeIndex - 1;
    setActiveIndex(newIndex);
    scrollToCenter(newIndex);
  };

  const handleNext = () => {
    const newIndex = activeIndex === videos.length - 1 ? 0 : activeIndex + 1;
    setActiveIndex(newIndex);
    scrollToCenter(newIndex);
  };

  return (
    <Box
      sx={{
        p: { xs: 2, md: 8 },
        backgroundColor: "#f1fdf6",
        position: "relative",
      }}
    >
      <ContentHeader
        heading={"Explore our videos"}
        paragraph={
          "Watch our latest tutorials and engaging content. Discover insights and stories that inspire."
        }
      />

      <Grid>
        {isMobile ? (
          <Box
            sx={{
              display: "flex",
              overflowX: "auto",
              scrollSnapType: "x mandatory",
              gap: 2,
              // pt: 2,
              scrollbarWidth: "none",
              "&::-webkit-scrollbar": {
                display: "none",
              },
            }}
          >
            {videos?.map((video, i) => (
              <Card
                key={i}
                ref={(el) => (videoRefs.current[i] = el)}
                sx={{
                  minWidth: 280,
                  flexShrink: 0,
                  scrollSnapAlign: "center",
                  boxShadow: 3,
                  position: "relative",
                }}
              >
                {i === activeIndex && video.type === "youtube" ? (
                  <YouTubeEmbed
                    url={`https://www.youtube.com/embed/${video.videoId}`}
                  />
                ) : (
                  <CardMedia
                    component="img"
                    image={video.image}
                    alt={video.title}
                    sx={{ height: 200, objectFit: "cover" }}
                  />
                )}
              </Card>
            ))}
          </Box>
        ) : (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              gap: 2,
              overflowX: "auto",
              scrollSnapType: "x mandatory",
              "&::-webkit-scrollbar": {
                display: "none",
              },
            }}
          >
            {videos.map((video, i) => (
              <Card
                key={i}
                ref={(el) => (videoRefs.current[i] = el)}
                sx={{
                  width: 300,
                  flexShrink: 0,
                  scrollSnapAlign: "center",
                  boxShadow: 3,
                  position: "relative",
                }}
              >
                {i === activeIndex && video.type === "youtube" ? (
                  <YouTubeEmbed
                    url={`https://www.youtube.com/embed/${video.videoId}`}
                  />
                ) : (
                  <CardMedia
                    component="img"
                    image={video.image}
                    alt={video.title}
                    sx={{ height: 200, objectFit: "cover" }}
                  />
                )}
              </Card>
            ))}
          </Box>
        )}

        {/* Dot Indicators */}
        <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
          {videos.map((_, i) => (
            <Box
              key={i}
              sx={{
                width: 10,
                height: 10,
                borderRadius: "50%",
                backgroundColor: i === activeIndex ? WEB_COLORS.darkTeal : "#ccc",
                mx: 0.5,
              }}
            />
          ))}
        </Box>
      </Grid>
    </Box>
  );
};

export default VideoCarousel;
